import EcheancesTab from "@features/comptabilite/components/echeances/EcheancesTab";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Calendar } from "lucide-react";

export const Route = createFileRoute("/_app/comptabilite/echeances/")({
  staticData: {
    title: "Échéances",
    icon: Calendar,
    tab_icon: Calendar,
    permission: PERMISSIONS.COMPTABILITE.ECHEANCES.VIEW,
    module: "comptabilite",
    order: 40,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: EcheancesTab,
});
